import { validateSKUs } from 'src/request/stock/stock';
import { ImportStockItem } from './ExcelParser';
import { ValidSkusItem } from '@/src/types/common/stock';
import { i18nGet } from '@/src/tools/tools';
export interface ValidateResult {
  validCount: number;
  invalidSkus: string[];
  validSkus: ValidSkusItem[];
}

export interface ValidationResult {
  success: boolean;
  result?: ValidateResult;
  errorMessage?: string;
}

// 创建用于导入的商品项，从校验的SKU和导入的数据结合
export interface ImportProductItem extends ValidSkusItem {
  quantity: number;
  notes: string;
}

/**
 * 通过后端API校验SKU列表
 * @param items 从Excel导入的项目
 * @returns 验证结果
 */
export const validateStockItems = async (
  items: ImportStockItem[],
  i18n: any,
): Promise<ValidationResult> => {
  const getI18n = (str: string) => i18nGet(i18n, str);
  try {
    // 提取所有SKU
    const skus = items.map((item) => item.sku);
    // 调用后端API校验SKU
    const result = await validateSKUs(skus);

    return {
      success: true,
      result,
    };
  } catch (error) {
    return {
      success: false,
      errorMessage: getI18n('stockIn.stock.judge_file_content_failed'),
    };
  }
};

/**
 * 将校验后的数据转换为可导入的格式
 * @param items 从Excel导入的项目
 * @param validationResult 验证结果
 * @returns 转换后的数据
 */
export const transformValidatedData = (
  items: ImportStockItem[],
  validationResult: ValidateResult,
): ImportProductItem[] => {
  const { validSkus } = validationResult;

  // 确保 validSkus 不为空
  if (!validSkus || !Array.isArray(validSkus) || validSkus.length === 0) {
    return [];
  }

  // 创建 SKU 到 Excel 数据的映射
  const skuToExcelMap: Record<string, ImportStockItem> = {};
  items.forEach((item) => {
    skuToExcelMap[item.sku] = item;
  });

  // 只保留有效的SKU项并关联数量和备注
  return validSkus.map((validItem) => {
    const excelItem = skuToExcelMap[validItem.sku] || {
      quantity: 0,
      notes: '',
    };

    return {
      ...validItem,
      quantity: excelItem.quantity || 0,
      notes: excelItem.notes || '',
    };
  });
};
